export class OrderCategory {
  public name: string;
  public version: string;
  public parameterName: string;
  public parameterStructure: string;
  public orderDiagnosticType: string;
}
